import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, OnDestroy, ViewEncapsulation, ElementRef, Renderer2, HostListener } from '@angular/core';
import { ReportObject, PageContent, ReportGroup, Metadata } from '../objects/WorkObject';
import { WorkspaceService } from '../services/workspace.service';
import { ConversationService } from '../services/conversation.service';
import { ConfirmationService } from '../services/confirmation.service';
import { group } from '@angular/animations';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ContextMenuComponent, ContextMenuService } from 'node_modules/ngx-contextmenu';
import { ThemeSettingService } from '../services/theme-setting.service';
import { LoadingSummaryService } from '../services/loading-summary.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { DetailService } from '../services/detail.service';
import { Subscription } from 'rxjs';
import { SummaryService } from '../services/summary.service';
import { WorkflowReturn, WorkflowReturnService } from '../services/workflow-return.service';
import { MainLoadingService } from '../services/main-loading.service';
import { MdePopover, MdePopoverTrigger } from '@material-extended/mde';
import { EnvService } from '../env.service';

@Component({
  selector: 'app-reportcard',
  templateUrl: './reportcard.component.html',
  styleUrls: ['./reportcard.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ReportcardComponent implements OnInit, OnDestroy {

  // @HostListener('document:click', ['$event'])
  // clickout(event) {
  //   var element = event.target as HTMLElement;
  //   if(element.classList.contains('btn-commentary')) {
  //     if (this.metadataObject){
  //       this.metadataObject.forEach(object => {
  //         // object.Metadata.forEach(metadata => {
  //         //   console.log(metadata)
  //         //   this.handleCommentaryBtn(metadata.MetadataValue, element);
  //         // });
  //         this.commentAction(element.getAttribute('data-action'));
  //       });
  //     }
  //   }
  // }

  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;
  @ViewChild('popoverTrigger') public mdePopover:MdePopoverTrigger;

  private paramList: any;
  private contentParamList: any;
  private hideOutline: boolean = false;
  private summaryComponentId:string;
  private summarySelectedId:string;
  private subSummarySelectedId:string;
  private summarySearchKeyword:string;
  private summaryNameChange:string;
  private summaryInputChange:string;
  private detailComponentId:string;
  private viewChangedId:string;
  private searchKeywordChanged:string;
  private searchPlaceholder:string;
  private searchKeyword:string;
  private khamisSearchChanged:string;
  private khamisSearchResultId:string;
  private searchResultChanged:string;
  private searchResultId:string;
  private menuComponentId:string;
  private menuComponentIdChanged:string;
  private inputComponentId:string;
  private chartComponentId:string;
  private keyIndicatorComponentId:string;
  private webContentComponentId:string;
  private progressChanged:string;
  private popupButtonId: string;
  private outlineComponentId:string;
  private outlineSelectedId:string;
  private inputValueChanged:string;
  private filterComboId: string;
  private filterComboChanged:string;
  private viewListId:string;
  private variables:object = {};
  private trueVar :boolean = true;
  private modalRef: BsModalRef;
  private subSummarySelectId: string;
  private propertyValueChanged: string;
  private emitValueChanged: string;
  private refreshView: boolean = false;
  private sub: Subscription;
  position: string;
  inputComboFilter: string;
  broadcastAction: string;
  broadcastDocId: string;
  broadcastDocType: string;
  broadcastType: string;
  broadcastColor: string;
  khamisSearchType: string;
  groupTypeInView: string;
  reportObject:ReportObject;
  metadataObject:MetadataObject[];
  isFlipped: boolean;
  triggerChartLoading: boolean = false;
  btnInstance: () => void;
  sampleValue = '<ol><li>A further review of trend anomalies across categories may be initiated.<br><span class="btn-commentary" data-action="TNDetails"><i class="fa fa-users"></i> Activate Review Team</span><span class="btn-commentary" data-action="RFQDetails"><i class="fa fa-address-card"></i> Contact VPC</span></li><br><li>Deep dive into the Packaging Material category to understand optimisation opportunities.<br><span class="btn-commentary" data-action="RFQ"><i class="fa fa-users"></i> Activate Review Team</span><span class="btn-commentary" data-action=""><i class="fa fa-address-card"></i> Contact VPC</span></li></ol>';

  @Input() pageContent:PageContent;
  @Input() reportGroupWidth: number;
  @Input() groupName: string;
  @Input() isFixHeight: boolean;
  @Input() dialog: boolean = false;

  @Output() variableChanged = new EventEmitter<object>();
  @Output() getRelatedEpic = new EventEmitter<ReportGroup>();
  @Output() hidePanel = new EventEmitter<boolean>();
  @Input() set setReport(report:ReportObject){
    this.reportObject = report;
    this.sortByMetadataType();
    if (this.reportObject.Metadata.length > 0){
      var types = this.reportObject.Metadata.map(item => item.MetadataTypeDescription).filter((value, index, self) => self.indexOf(value) === index);
      this.metadataObject = [];
      types.forEach(element => {
        var list = this.reportObject.Metadata.filter(x => x.MetadataTypeDescription== element);
        list = this.sortByMetadataName(list);

        this.metadataObject.push({Type: element, Metadata: list});
      });
    }
    this.MapBindingIds();

    if (this.reportObject.ContentInitializeParameter.startsWith("@"))
    {
      var urlParam = this.reportObject.ContentInitializeParameter.split(":")[0];
      var initParamName = this.reportObject.ContentInitializeParameter.split(":")[1];
      if (urlParam && this.route.snapshot.paramMap.get(urlParam))
      {
        this.SetVariableValue(initParamName, this.route.snapshot.paramMap.get(urlParam));
      }
    }
    else {
      this.paramList = new Array();
      this.contentParamList = new Array();
      this.route.snapshot.paramMap.keys.forEach(key => {
        if (key.startsWith("@")){
          this.paramList.push({ key : key, value : this.route.snapshot.paramMap.get(key)})
        }
      });

      if (this.reportObject.TemplateType == "Charts"){
        this.triggerChartLoading = true;
      }
      
      this.workspaceService.getEPICContent(this.reportObject.GroupId, this.reportObject.EPICId, this.paramList).subscribe(result=>{
        if(result){
          this.SetVariableValue(this.reportObject.ContentInitializeParameter, result);
        }
        else{
          if (this.reportObject.TemplateType == "Charts"){
            this.triggerChartLoading = false;
          }
        }
      }, error => {
        if (this.reportObject.TemplateType == "Charts"){
          this.triggerChartLoading = false;
        }
      })
    }
    this.constructRatio(this.reportObject);
    this.replaceURLParam();
  }

  @Input() set updateVariable(groupVariables:object){
    var tempVar = Object.assign({}, groupVariables);
    this.variables = tempVar;
  }

  constructor(private contextMenuService: ContextMenuService, 
    private workspaceService:WorkspaceService,
    private conversationService:ConversationService, 
    private confirmationService:ConfirmationService, 
    private route:ActivatedRoute, 
    private modalService: BsModalService,
    private router:Router,
    private themeSettingService:ThemeSettingService,
    private loadingSummaryService: LoadingSummaryService,
    private detailService: DetailService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private summaryService: SummaryService,
    private workflowReturn: WorkflowReturnService,
    private mainLoadingService: MainLoadingService,
    private env: EnvService) { 
      this.sub = themeSettingService.themeSettingChanged$.subscribe(value => {
        if (this.reportObject.BackgroundColor != "#FFF"){
          this.reportObject.BackgroundColor = value.primaryColour;
        }
      });
  }

  ngOnInit() {
  }

  ngOnDestroy(){
    if (this.sub) this.sub.unsubscribe();
  }

  replaceURLParam(){
    if (this.reportObject.Content.toUpperCase().indexOf("@URLPARAM") > -1)
    {
      var urlParam = this.reportObject.Content.substr(this.reportObject.Content.indexOf("@")).replace("}", "").replace(" ", "").replace('"', '');
      this.paramList.forEach(element => {
        if (element.key.toUpperCase().trim() === urlParam.toUpperCase().trim()){
          this.reportObject.Content = this.reportObject.Content.replace(new RegExp('\n','g'), "");
          var tempObj = JSON.parse(this.reportObject.Content);
          this.groupTypeInView = tempObj["GroupType"].replace(urlParam.trim(), element.value);
        }
      });
    }

    if (this.reportObject.Content.indexOf("InputFilterValue") > -1){
      var tempObj = JSON.parse(this.reportObject.Content.replace(new RegExp('\n','g'), ""));
      this.inputComboFilter = tempObj["InputFilterValue"];
    }
    
    if (this.reportObject.TemplateType.toUpperCase() == "POPUPBUTTON"){
      var tempObj = JSON.parse(this.reportObject.Content.replace(new RegExp('\n','g'), ""));
      // if (this.reportObject.Content.indexOf("Action") > -1){
      this.broadcastAction = tempObj["Action"];
      // }
      this.broadcastDocId = this.route.snapshot.paramMap.get(tempObj["DocId"]);
      this.broadcastDocType = tempObj["DocType"];
      this.broadcastType = tempObj["Type"];
      if (tempObj["Color"]){
        this.broadcastColor = tempObj["Color"];
      }
      else{
        this.broadcastColor = "#af2bbf";
      }
    }
    else if (this.reportObject.TemplateType.toUpperCase() == "KHAMISSEARCH"){
      if (this.reportObject.Content){
        var tempObj = JSON.parse(this.reportObject.Content.replace(new RegExp('\n','g'), ""));

        this.khamisSearchType = tempObj["Type"];
      }
    }
  }

  popover(trigger){

    if (this.btnInstance) {
      this.btnInstance();
    }

    setTimeout(() => {
      if (this.elRef.nativeElement.querySelector('.btn-commentary')){
        this.btnInstance = this.renderer.listen('document', 'click', (evt) => {
          var element = evt.target;
          if (element){
            if (element.className == "btn-commentary"){
              var dataAction = element.getAttribute('data-action');
              var summaryItemId = element.getAttribute('data-summaryitemid');
              var sectionId = element.getAttribute('data-sectionid');
              var groupId = element.getAttribute('data-groupid');
              var compareIds = element.getAttribute('data-compareids');
              this.commentAction(dataAction, summaryItemId, sectionId, groupId, compareIds);
            }
          }
        });
      }
    })
  }

  popoverClose(){
    if (this.btnInstance){
      this.btnInstance();
    }
  }

  commentAction(dataAction: any, summaryItemId: string, sectionId: string, groupId: string, compareIds: string){
    //find TN/RFQ summary
    if (dataAction == "RFQDetails") {
      // data-summaryitemid
      this.mainLoadingService.setLoading(true);
      this.summaryService.createSummary("RFQ", "DefaultView").subscribe(summaryId => {
        if (summaryId){
          this.summaryService.selectItem(summaryId, summaryItemId).subscribe(wfs => { //summaryitemid
            if (wfs){
              this.mdePopover.closePopover();
              this.popoverClose();
              var wfAction = JSON.parse(wfs);
              this.workflowReturn.handleWorkflowReturn(wfAction, true);
              this.mainLoadingService.setLoading(false);
            }
          }, error => {
            this.mainLoadingService.setLoading(false);
          })
        }
      }, error => {
        this.mainLoadingService.setLoading(false);
      })
    }
    else if (dataAction == "RFQ") {
      // data-summaryitemid
      this.mainLoadingService.setLoading(true);
      var action = "RFQ_COMPAREQUOTE";
      this.summaryService.createSummary("RFQ", "DefaultView").subscribe(summaryId => {
        if (summaryId){
          this.summaryService.selectItem(summaryId, summaryItemId).subscribe(wfs => { //summaryitemid
            if (wfs){
              var wf = JSON.parse(wfs);
              if (wf.Arguments[0] && wf.ReturnType == 3){
                var detailId = wf.Arguments[0];
                this.detailService.detailAction(detailId, action).subscribe(actionResult => {
                  this.mdePopover.closePopover();
                  this.popoverClose();
                  var wfAction = JSON.parse(actionResult);
                  this.workflowReturn.handleWorkflowReturn(wfAction);
                  this.mainLoadingService.setLoading(false);
                }, error => {
                  this.mainLoadingService.setLoading(false);
                })
              }
            }
          }, error => {
            this.mainLoadingService.setLoading(false);
          })
        }
      }, error => {
        this.mainLoadingService.setLoading(false);
      })
    }
    else if (dataAction == "TNDetails"){
      // data-summaryitemid
      this.mainLoadingService.setLoading(true);
      this.summaryService.createSummary("TN", "BuyerView").subscribe(summaryId => {
        if (summaryId){
          this.summaryService.selectItem(summaryId, summaryItemId).subscribe(wfs => { //summaryitemid
            if (wfs){
              this.mdePopover.closePopover();
              this.popoverClose();
              var wfAction = JSON.parse(wfs);
              this.workflowReturn.handleWorkflowReturn(wfAction, true);
              this.mainLoadingService.setLoading(false);
            }
          }, error => {
            this.mainLoadingService.setLoading(false);
          })
        }
      }, error => {
        this.mainLoadingService.setLoading(false);
      })
    }
    else if (dataAction == "TN"){
      // data-summaryitemid
      // data-sectionId
      // data-groupId
      // data-compareIds
      this.mainLoadingService.setLoading(true);
      var action = "TNDB_COMPARE";
      this.summaryService.createSummary("TN", "BuyerView").subscribe(summaryId => {
        if (summaryId){
          this.summaryService.selectItem(summaryId, summaryItemId).subscribe(wfs => { //summaryitemid
            if (wfs){
              var wf = JSON.parse(wfs);
              if (wf.Arguments[0] && wf.ReturnType == 3){
                var detailId = wf.Arguments[0];
                 this.detailService.changeSection(detailId, sectionId) .subscribe(wfss => { //sectionId
                    if (wfss == "1"){
                      this.summaryService.getNewSummaryFromDetail(detailId, groupId, false).subscribe(summaryGroupId =>{  //groupId
                        if (summaryGroupId){
                          var listOf = [];// list of selectedIds
                          if (compareIds){
                            compareIds.split(",").forEach(id => {
                              listOf.push([{name: "DocumentInstanceId", value: id.trim()}]);
                            });
                          }
                          // listOf.push([{name: "DocumentInstanceId", value: "87651b6a-0bcb-4f4d-b9c7-f7946344707d"}]);
                          // listOf.push([{name: "DocumentInstanceId", value: "5b415fb4-00c1-4c48-abb4-280be2ee6a98"}]);
                          // listOf.push([{name: "DocumentInstanceId", value: "6eaa716a-98dd-40e9-abcc-19a2c0059abe"}]);
                          // var parentList = [];
                          // parentList.push(listOf);
                          this.summaryService.summaryAction(summaryGroupId, listOf, action).subscribe(actionResult => {
                            this.mdePopover.closePopover();
                            this.popoverClose();
                            var wfAction = JSON.parse(actionResult);
                            this.workflowReturn.handleWorkflowReturn(wfAction);
                            this.mainLoadingService.setLoading(false);
                          }, error => {
                            this.mainLoadingService.setLoading(false);
                          })
                        }
                      }, error => {
                        this.mainLoadingService.setLoading(false);
                      })
                    }
                 }, error => {
                  this.mainLoadingService.setLoading(false);
                })
              }
            }
          }, error => {
            this.mainLoadingService.setLoading(false);
          })
        }
      }, error => {
        this.mainLoadingService.setLoading(false);
      })
    }
    
  }

  sortByMetadataType(){
    this.reportObject.Metadata.sort((a:Metadata,b:Metadata) => {
      if(a.MetadataTypeSequence > b.MetadataTypeSequence){
        return 1;
      }else if(a.MetadataTypeSequence < b.MetadataTypeSequence){
        return -1;
      }else{
        return 0;
      }
    })
  }

  sortByMetadataName(list:Metadata[]):Metadata[]{
    return list.sort((a:Metadata,b:Metadata) => {
      if(a.MetadataNameSequence > b.MetadataNameSequence){
        return 1;
      }else if(a.MetadataNameSequence < b.MetadataNameSequence){
        return -1;
      }else{
        return 0;
      }
    })
  }

  getRelatedEpics(reportGroup:any){
    this.getRelatedEpic.emit(reportGroup);
  }

  MapBindingIds() {
    if(this.reportObject.ContentInput)
    {
      var input = JSON.parse(this.reportObject.ContentInput);
      if(input){
        switch(this.reportObject.TemplateType.toUpperCase()){
          case "DOCUMENTSUMMARY":
            this.summaryComponentId = input["componentId"];
            this.summarySearchKeyword = input["searchKeyword"];
            this.summaryInputChange = input["filterInput"];
            break;
          case "DOCUMENTSUBSUMMARY":
            this.summaryComponentId = input["componentId"];
            this.summarySearchKeyword = input["searchKeyword"];
            break;
          case "DOCUMENTDETAIL":
            this.detailComponentId = input["setComponentId"];
            break;
          case "SEARCHBAR":
            this.searchPlaceholder = input["placeholder"];
            this.searchKeyword = input["searchKeyword"];
            break;
          case "SEARCHRESULT":
            this.searchResultChanged = input["searchResultChanged"];
            this.searchResultId = input["searchResultId"];
            break;
          case "MENU":
            this.menuComponentId = input["componentId"];
            break;
          case "INPUTBAR":
            this.inputComponentId = input["componentId"];
            break;
          case "CHARTS":
            this.chartComponentId = input["componentId"];
            break;
          case "OUTLINE":
            this.outlineComponentId = input["componentId"];
            break;
          case "INPUTCOMBO":
            this.filterComboId = input["componentId"];
            break;
          case "VIEWLIST":
            this.viewListId = input["componentId"];
            break;
          case "KEYINDICATOR":
            this.keyIndicatorComponentId = input["componentId"];
            break;
          case "WEBCONTENT":
            this.webContentComponentId = input["componentId"];
            break;
          case "VERTICALPROGRESS":
            this.progressChanged = input["progressChanged"];
          break;
          case "POPUPBUTTON":
            this.popupButtonId = input["componentId"];
          break;

        }
      }
      var output = JSON.parse(this.reportObject.ContentOutput);
      if(output){
        switch(this.reportObject.TemplateType.toUpperCase()){
          case "DOCUMENTSUMMARY":
            this.summarySelectedId = output["selectedId"];
            this.summaryNameChange = output["nameChange"];
            this.searchKeywordChanged = output["keywordChanged"];
            break;
          case "DOCUMENTSUBSUMMARY":
            this.subSummarySelectedId = output["selectedId"];
            this.summaryNameChange = output["nameChange"];
            break;
          case "DOCUMENTDETAIL":
            this.subSummarySelectId = output["subSummarySelectId"];
            this.propertyValueChanged = output["propertyValueChanged"];
            this.emitValueChanged = output["emitValue"];
            break;
          case "VIEWLIST":
            this.viewChangedId = output["viewChangedId"];
            break;
          case "SEARCHBAR":
            this.searchKeywordChanged = output["keywordChanged"];
            break;
          case "KHAMISSEARCH":
            this.khamisSearchChanged = output["searchChanged"];
            this.khamisSearchResultId = output["searchResultId"];
            break;
          case "MENU":
            this.menuComponentIdChanged = output["menuSelectedId"];
            break;
          case "INPUTBAR":
            this.inputValueChanged = output["inputChanged"];
            break;
          case "OUTLINE":
            this.outlineSelectedId = output["selectedDetailId"];
            break;
          case "INPUTCOMBO":
            this.filterComboChanged = output["selectionChanged"];
            break;
        }
      }
    }
  }

  SetVariableValue(varName:string, value:any){
    if(varName.startsWith('@@')){
      if (value != 1 && value != 0){ //used for loading
        var command = varName.split(":")[0].replace("@@", "").toUpperCase();

        var params:string[] = varName.substring(command.length+3).split(":");
  
        params.push(value);
  
        switch(command){
          case "NAVIGATE":
            this.router.navigate(params);
            break;
          case "POPUP":
          this.openPopup(value);
            break;
        }
      }
    }else{
      this.variables[varName] = value;
      this.variableChanged.emit(this.variables);
    }
  }

  GetOutputVariableName(paramName:string):string{
    if(this.reportObject != null){
      var output = JSON.parse(this.reportObject.ContentOutput);
      if(output){
        return output[paramName];
      }else{
        return '';
      }
    }else{
      return '';
    }
  }

  openPopup(event, title: string = "") {
    this.clearSummarySelectedItem(event);
    var template: TemplateRef<any>;
    // const initialState = {
    //   componentId: event,
    //   title: title
    // };

    const config: ModalOptions = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-detail',
      initialState: {
        componentId: event,
        title: title
      }
    };

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
    })

    this.modalRef = this.modalService.show(DetailPopupComponent, config);
  }

  clearSummarySelectedItem(id: string){
    this.detailService.clearSummarySelectedItem(id).subscribe(result => {
      //console.log(result); handle
    })
  }

  constructRatio(reportObject:ReportObject){
    reportObject.FilledSpace = 0;
    if (reportObject.HasHeaderTitle || reportObject.HeaderTitle){
      reportObject.FilledSpace += this.fontFormat(reportObject.HeaderTitleType);
    }
    else if (reportObject.HasHeaderValue || reportObject.HeaderValue){
      reportObject.FilledSpace += this.fontFormat(reportObject.HeaderValueType);
    }
    else if ((reportObject.HasSubFooterTitle && reportObject.SubFooterTitle) || (reportObject.HasFooterTitle && reportObject.FooterTitle)){
      reportObject.FilledSpace += this.fontFormat(reportObject.FooterTitleType);
    }
    else if ((reportObject.HasSubFooterValue && reportObject.SubFooterValue) || (reportObject.HasFooterValue && reportObject.FooterValue)){
      reportObject.FilledSpace += this.fontFormat(reportObject.FooterValueType);
    }
    else{
      reportObject.FilledSpace += 0.5;
    }
    reportObject.FilledSpace += 0.5;
  }

  fontFormat(format:string):number{
    var value = 0;
    switch(format.toUpperCase()){
      case "HEADER":
        value = 1.5;
        break;
      case "SUBHEADER":
        value = 1;
        break;
      case "REGULAR":
        value = 1;
        break;
      case "REGULARBOLD":
        value = 1;
        break;
      case "LIGHT":
        value = 0.6875;
        break; 
    }
    return value;
  }

  public onContextMenu($event, item: any): void {
    if($event.button == 0){
      this.contextMenuService.show.next({
        contextMenu: this.basicMenu,
        event: $event,
        item: item,
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  togglePanel(){
    this.reportObject.IsCollapsed = !this.reportObject.IsCollapsed;
    this.hidePanel.emit(this.reportObject.IsCollapsed);
  }

  pullPopupUtterance(reportObject: ReportObject) {
    this.confirmationService.confirm(
      'Add Quick Phrase for ' + reportObject.EPICName,
      '',
      ['CANCEL', 'OK'], true, 'Add Quick Phrase...', true)
      .subscribe((respond) => {
        if (respond.answer == 'OK'){
          // this.isBusy = true;
          this.conversationService.saveUtteranceForEPIC(respond.inputText, reportObject.EPICId).subscribe(result => {
            // console.log(result);
          });
        }
      });

    // $event.stopPropagation();
  }

  pullPopupTag(reportObject: ReportObject) {
    this.confirmationService.confirm(
      'Add Tag for ' + reportObject.EPICName,
      '',
      ['CANCEL', 'OK'], true, 'Add Tag...', true)
      .subscribe((respond) => {
        if (respond.answer === 'OK') {
          // this.isBusy = true;
          this.conversationService.saveUserTagForEPIC(respond.inputText, reportObject.EPICId).subscribe(result => {
            // console.log(result);
          });
        }
      });
    // $event.stopPropagation();
    }

    addMetadata(reportObject: ReportObject){
      this.mainLoadingService.setLoading(true);
      this.conversationService.saveMetadataForEPIC(reportObject.TemplateType, reportObject.EPICId).subscribe(result => {
        this.mainLoadingService.setLoading(false);
        if (result){
          this.workflowReturn.handleWorkflowReturn(JSON.parse(result));
        }
      }, error => {
        this.mainLoadingService.setLoading(false);
      });
    }
  }

export class MetadataObject {
  Type: string;
  Metadata: Metadata[];
}
